const BRANCH_SIGNUP_SOURCE_COOKIE = 'gus_branch_signup_source';
const THIRTY_DAYS_SECONDS = 30 * 24 * 60 * 60;

function secureCookieFlag(): string {
  return typeof window !== 'undefined' && window.location.protocol === 'https:' ? '; Secure' : '';
}

function buildCookieSuffix(): string {
  return `; Path=/; Max-Age=${THIRTY_DAYS_SECONDS}; SameSite=Lax${secureCookieFlag()}`;
}

export function readBranchSignupSourceCookie(): string | null {
  if (typeof document === 'undefined') {
    return null;
  }
  const prefix = `${BRANCH_SIGNUP_SOURCE_COOKIE}=`;
  for (const raw of document.cookie.split(';')) {
    const part = raw.trim();
    if (part.startsWith(prefix)) {
      const value = decodeURIComponent(part.slice(prefix.length));
      return value ? value : null;
    }
  }
  return null;
}

export function writeBranchSignupSourceCookie(source: string): void {
  if (typeof document === 'undefined' || !source) {
    return;
  }
  document.cookie = `${BRANCH_SIGNUP_SOURCE_COOKIE}=${encodeURIComponent(source)}${buildCookieSuffix()}`;
}

export function clearBranchSignupSourceCookie(): void {
  if (typeof document === 'undefined') {
    return;
  }
  document.cookie = `${BRANCH_SIGNUP_SOURCE_COOKIE}=; Path=/; Max-Age=0; SameSite=Lax${secureCookieFlag()}`;
}
